// client/src/components/Admin/PlanesEducaCmp/_shared/PlanAccountTag.js
//
// M07 - Tag de tipo de cuenta del plan (free / premium / promocion).
// Mismos valores que el campo `account` del modelo PlanEduca.

import React from "react";
import { CrownFilled, GiftFilled, TagFilled } from "@ant-design/icons";
import styles from "./PlanAccountTag.module.scss";

const META = {
  free: { label: "Free", icon: <TagFilled />, className: "free" },
  premium: { label: "Premium", icon: <CrownFilled />, className: "premium" },
  promocion: {
    label: "Promocion",
    icon: <GiftFilled />,
    className: "promocion",
  },
};

export function PlanAccountTag({ account }) {
  const meta = META[account] || {
    label: account || "Sin tipo",
    icon: null,
    className: "unknown",
  };
  return (
    <span className={`${styles.tag} ${styles[meta.className]}`}>
      {meta.icon ? <span className={styles.icon}>{meta.icon}</span> : null}
      {meta.label}
    </span>
  );
}
